import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Form, Input, Select, Switch, Button, Divider} from 'antd'
import PasswordModal from './Modals/Password'
import DisableModal from './Modals/Disable'

import style from './style.sass'

@inject('store') @observer
class Profile extends Component {
  state = {
    passwordModal: false,
    disableModal: false
  }
  resetHandler = () => {
    this.props.store.user.reset()
  }
  submitHandler = (e) => {
    e.preventDefault()
    this.props.store.user.changeData()
  }
  changeHandler = (e) => {
    this.props.store.user.changeField(e.target.name, e.target.value)
  }
  toggleProfessional = (checked) => {
    this.props.store.user.changeField('is_professional_trader', checked)
  }
  handleMultiselect = (value) => {
    this.props.store.user.changeField('instruments2', value)
  }
  openPasswordModal = () => {
    this.setState({passwordModal: true})
  }
  closePasswordModal = () => {
    this.setState({passwordModal: false})
  }
  openDisableModal = () => {
    this.setState({disableModal: true})
  }
  closeDisableModal = () => {
    this.setState({disableModal: false})
  }
  render() {
    const {store} = this.props
    const logout = () => store.auth.logout()
    const toggle = name => this.props.store.user.changeNotification(name)
    const {changed, dataToUpdate, validationErrors} = store.user
    const notifications = dataToUpdate.account && Array.isArray(dataToUpdate.account.notifications) ? dataToUpdate.account.notifications : []
    const {permissions} = store

    const emailPermission = notifications.includes('email') ? 'account.email_notifications.disable' : 'account.email_notifications.enable'
    const smsPermission = notifications.includes('sms') ? 'account.sms_notifications.disable' : 'account.sms_notifications.enable'
    return(
      <Form onReset={this.resetHandler} onSubmit={this.submitHandler} styleName='wrapper'>
        <PasswordModal visible={this.state.passwordModal} close={this.closePasswordModal}/>
        <DisableModal visible={this.state.disableModal} close={this.closeDisableModal}/>
        <Form.Item
          label='First Name'
        >
          <Input
            onChange={this.changeHandler}
            value={dataToUpdate.first_name}
            name='first_name'
            type='text'
          />
        </Form.Item>
        <Form.Item
          label='Last Name'
        >
          <Input
            onChange={this.changeHandler}
            value={dataToUpdate.last_name}
            name='last_name'
            type='text'
          />
        </Form.Item>
        <Form.Item
          styleName='full-width'
        >
          <span>Professional Trader </span>
          <Switch
            onChange={this.toggleProfessional}
            checked={dataToUpdate.is_professional_trader}
          />
        </Form.Item>
        <Form.Item
          label='Asset Classes'
          styleName='full-width'
        >
          <Select
            name='instruments2'
            style={{width:'100%'}}
            mode='multiple'
            value={dataToUpdate.instruments2}
            onChange={this.handleMultiselect}
          >
            <Select.Option value='equities'>equities</Select.Option>
            <Select.Option value='currencies'>currencies</Select.Option>
            <Select.Option value='commodities'>commodities</Select.Option>
            <Select.Option value='bonds'>bonds</Select.Option>
            <Select.Option value='derivatives'>derivatives</Select.Option>
            <Select.Option value='other'>other</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          label='Notifications'
          styleName='full-width'
        >
          <span styleName='notifications' className={permissions.checkUpgrade(emailPermission) ? 'upgrade-ribbon' : ''}>
            Email <Switch
              onChange={() => permissions.wrap(emailPermission, () => toggle('email'))}
              checked={notifications.includes('email')}
              disabled={!permissions.check(emailPermission)}
            />
          </span>
          <span styleName='notifications' className={permissions.checkUpgrade(smsPermission) ? 'upgrade-ribbon' : ''}>
            SMS <Switch
              onChange={() => permissions.wrap(smsPermission, () => toggle('sms'))}
              checked={notifications.includes('sms')}
              disabled={!permissions.check(smsPermission)}
            />
          </span>
        </Form.Item>
        <Form.Item
          label='Phone Number'
          validateStaus={validationErrors.phone ? 'error' : null}
          help={validationErrors.phone}
        >
          <Input
            onChange={this.changeHandler}
            value={dataToUpdate.phone}
            name='phone'
            type='tel'
          />
        </Form.Item>
        <Form.Item
          label='Email'
        >
          <span styleName='email'>{dataToUpdate.email}</span>
        </Form.Item>
        <Form.Item
          styleName='date-joined'
        >
          You joined us on
          <b>{dataToUpdate.date_joined && ' ' + new Date(dataToUpdate.date_joined).toLocaleDateString('en-US')}</b>
        </Form.Item>
        <Form.Item
          styleName='actions'
        >
          <a
            onClick={this.openPasswordModal}
            disabled={!permissions.check('account.password.update')}
          >
            Change password
          </a>
          <a
            styleName='disable'
            onClick={this.openDisableModal}
            disabled={!permissions.check('account.delete')}
          >
            Disable account
          </a>
        </Form.Item>
        <Divider styleName='divider'/>
        <Form.Item
          styleName='footer'
        >
          <div styleName='form-actions'>
            <Button
              type='primary'
              htmlType='submit'
              disabled={!changed}
            >
              Save
            </Button>
            <Button
              htmlType='reset'
              disabled={!changed}
            >
              Cancel
            </Button>
          </div>
          <Button
            type='danger'
            onClick={logout}
          >
            Logout
          </Button>
        </Form.Item>
      </Form>
    )
  }
}

export default Profile
